import styled from 'styled-components';

/* Mixins */
import { WebFontBody1, WebFontBody2 } from 'styles/Mixins';
import { opaque } from 'styles/Utils';

/* Assets */
import PoweredByGoogleImg from 'assets/PoweredByGoogle.png';

export const AutocompleteContainerWrapper = styled.div`
  position: relative;
`;

export const AutocompleteContainer = styled.div`
  z-index: ${({ theme }) => theme.zIndexOverlay1};
  width: 100%;
  position: absolute;
  pointer-events: none;
`;

export const AutocompleteResultsContainer = styled.div`
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 1px 7px 1px ${({ theme }) => opaque(theme.Grey5, 0.8)};
  border-radius: 4px;
  overflow: hidden;
  pointer-events: all;
`;

export const AutocompleteResult = styled.div<{ [props: string]: any }>`
  padding: 4px;
  cursor: pointer;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.Grey6 : theme.white};

  :hover {
    background: ${({ theme }) => theme.Grey6};
  }
`;

export const AutocompleteResultMainText = styled.span`
  ${WebFontBody1};
  color: ${({ theme }) => theme.Grey1};
`;

export const AutocompleteResultSecondaryText = styled.span`
  ${WebFontBody2};
  color: ${({ theme }) => theme.Grey2};
  margin-left: 4px;
`;

export const GoogleAttribution = styled.img.attrs(() => ({
  src: PoweredByGoogleImg,
}))`
  float: right;
  margin-top: 4px;
`;
